package top.wcpe.allincore.dsl.compiler.pipeline

import top.wcpe.allincore.dsl.compiler.theme.ThemeModifier

/**
 * 主题修饰 Pass：对声明了 `modifiers.compact` / `modifiers.highContrast` 的主题应用
 * [ThemeModifier] 的几何缩放 / 对比增强。无修饰的主题零开销跳过。
 *
 * 运行时机：[DerivativeThemePass] 之后——修饰作用于继承 flatten + 派生补全后的完整 token，
 * 保证缩放/增强覆盖所有几何与状态层值。
 */
class ThemeModifierPass(
    private val registry: ThemeRegistry,
) {

    fun apply() {
        for (scheme in registry.schemes().toList()) {
            val tokens = registry.lookup(scheme) ?: continue
            if (!ThemeModifier.hasModifier(tokens)) continue
            registry.register(scheme, ThemeModifier.apply(LinkedHashMap(tokens)))
        }
    }
}
